module.exports = __webpack_public_path__ + "static/media/bannerTL.4fbcb59a.webp";